import http from 'src/infrastructure/http'
import {
  parseGoodResponse,
  parseFailedResponse,
} from 'src/infrastructure/parse-axios-response'
import {
  ApplyInvoicesManagementApiParams,
  AssociateProductsReceivementPayload,
  ConfirmWrongProductPayload,
  GenericApiErrors, GetPendingReceivementPayload, GetReceivementConferenceParams,
  PendingReceivements, ProductWrong, ReceivementConference, SendReceivementConferenceParams, ValidateInvoiceKeyApiParams,
} from './PendingReceivementsTypes'

const getPendingReceivements = async (fulfillmentCenterId: GetPendingReceivementPayload) => {
  try {
    const result = await http.get(`/v2/receivement/pending/${fulfillmentCenterId}`)

    return parseGoodResponse<PendingReceivements>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getReceivementConference = async ({
  badge,
  receivementId,
}: GetReceivementConferenceParams) => {
  try {
    const result = await http.get(`/v2/receivement/pending/${receivementId}/conference`, {
      headers: {
        'user-barcode': badge,
      },
    })

    return parseGoodResponse<ReceivementConference>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const sendReceivementConference = async ({
  badge,
  receivementId,
  receivementConference,
}: SendReceivementConferenceParams) => {
  try {
    const result = await http.post(`/v2/receivement/pending/${receivementId}/close`,
      {
        receivement_conference: receivementConference?.map((conference) => ({
          id_model: conference.modelId,
          product_description: conference.productDescription,
          invoice_details: conference.invoiceDetails.map((invoiceDetail) => ({
            id_model: conference.modelId,
            accepted_quantity: invoiceDetail.acceptedQuantity,
            box_quantity: invoiceDetail.boxQuantity,
            qty_per_box: invoiceDetail.qtyPerBox,
            expected_quantity: invoiceDetail.expectedQuantity,
            received_quantity: invoiceDetail.receivedQuantity,
            id_ar: invoiceDetail.idAr,
            invoice_checker: invoiceDetail.invoiceChecker,
            invoice_key: invoiceDetail.invoiceKey,
            id_ar_item: invoiceDetail.idArItem,
          })),
        })),
      }, {
        headers: { 'user-barcode': badge },
      })

    return parseGoodResponse(result)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const validateSupervisorBadge = async (badge) => {
  try {
    const resultSuccess = await http.post('/v2/receivement/pending/validate/badge', null, {
      headers: { 'user-barcode': badge },
    })
    return parseGoodResponse(resultSuccess)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const validateInvoiceKey = async ({ receivementId, invoiceKey, badge }: ValidateInvoiceKeyApiParams) => {
  try {
    const resultSuccess = await http.post('/v2/recebimento/validate-invoice', {
      id_receivement: receivementId,
      invoice_key: invoiceKey,
    }, {
      headers: { 'user-barcode': badge },
    })
    return parseGoodResponse(resultSuccess)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const applyInvoicesManagement = async ({ receivementId, invoiceKeys, badge }: ApplyInvoicesManagementApiParams) => {
  try {
    const result = await http.post('/v2/recebimento/manage/invoices', {
      id_receivement: receivementId,
      invoice_keys: invoiceKeys,
    }, {
      headers: { 'user-barcode': badge },
    })

    return parseGoodResponse<ReceivementConference>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const associateProductsReceivementThirdConference = async (payload: AssociateProductsReceivementPayload) => {
  const {
    badge, receivementId, idArItem, currentIdModel, newIdModel,
  } = payload
  try {
    const result = await http.post('/v2/recebimento/third-conference/products-association', {
      id_receivement: receivementId,
      id_ar_item: idArItem,
      current_id_model: currentIdModel,
      new_id_model: newIdModel,
    }, {
      headers: { 'user-barcode': badge },
    })

    return parseGoodResponse<ReceivementConference>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const confirmWrongProduct = async (payload: ConfirmWrongProductPayload) => {
  const { badge, idProductDivergence } = payload
  try {
    const result = await http.put(`/v2/recebimento/third-conference/confirm-wrong-product/${idProductDivergence}`, {}, {
      headers: { 'user-barcode': badge },
    })

    return parseGoodResponse<ProductWrong>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  getPendingReceivements,
  getReceivementConference,
  sendReceivementConference,
  validateSupervisorBadge,
  validateInvoiceKey,
  applyInvoicesManagement,
  associateProductsReceivementThirdConference,
  confirmWrongProduct,
}
